export default __webpack_public_path__ + "static/media/a012-market-line-2.89355c9e.svg";